import type { StudyEvaluationMode } from '../learningEngineV2/studyEvaluationFlow';

export type StudyInteractionPolicyV2 = {
  firstPassEditable: boolean;
  correctionEditable: boolean;
  showFirstPassAction: boolean;
  showCorrectionAction: boolean;
  allowBatchRequest: boolean;
  allowCorrectionRequest: boolean;
  submissionPending: boolean;
  awaitReview: boolean;
  completed: boolean;
};

/**
 * Central UI mutation policy for Study V2.
 *
 * The evaluator state owns whether the student may still mutate the worksheet.
 * This prevents the local UI from diverging from an already-dispatched payload.
 */
export function studyInteractionPolicyV2(mode: StudyEvaluationMode): StudyInteractionPolicyV2 {
  switch (mode) {
    case 'study':
      return {
        firstPassEditable: true,
        correctionEditable: false,
        showFirstPassAction: true,
        showCorrectionAction: false,
        allowBatchRequest: true,
        allowCorrectionRequest: false,
        submissionPending: false,
        awaitReview: false,
        completed: false,
      };
    case 'error':
      return {
        firstPassEditable: true,
        correctionEditable: false,
        showFirstPassAction: true,
        showCorrectionAction: false,
        allowBatchRequest: true,
        allowCorrectionRequest: false,
        submissionPending: false,
        awaitReview: false,
        completed: false,
      };
    case 'batch_submitting':
      return {
        firstPassEditable: false,
        correctionEditable: false,
        showFirstPassAction: true,
        showCorrectionAction: false,
        allowBatchRequest: false,
        allowCorrectionRequest: false,
        submissionPending: true,
        awaitReview: false,
        completed: false,
      };
    case 'correction':
      return {
        firstPassEditable: false,
        correctionEditable: true,
        showFirstPassAction: false,
        showCorrectionAction: true,
        allowBatchRequest: false,
        allowCorrectionRequest: true,
        submissionPending: false,
        awaitReview: false,
        completed: false,
      };
    case 'correction_submitting':
      return {
        firstPassEditable: false,
        correctionEditable: false,
        showFirstPassAction: false,
        showCorrectionAction: true,
        allowBatchRequest: false,
        allowCorrectionRequest: false,
        submissionPending: true,
        awaitReview: false,
        completed: false,
      };
    case 'await_review':
      return {
        firstPassEditable: false,
        correctionEditable: false,
        showFirstPassAction: false,
        showCorrectionAction: false,
        allowBatchRequest: false,
        allowCorrectionRequest: false,
        submissionPending: false,
        awaitReview: true,
        completed: false,
      };
    case 'completed':
      return {
        firstPassEditable: false,
        correctionEditable: false,
        showFirstPassAction: false,
        showCorrectionAction: false,
        allowBatchRequest: false,
        allowCorrectionRequest: false,
        submissionPending: false,
        awaitReview: false,
        completed: true,
      };
  }
}
